<template>
  <div class="tab-name-edit">
    <SDialog v-model:open="modalVisibility">
      <SDialogContent
        class="tab-name-edit !w-[65%] !max-w-[65%] !top-[5vh] !translate-y-0"
        @open-auto-focus.prevent
      >
        <SDialogHeader>
          <SDialogTitle class="flex items-center gap-4">
            <SvgIcon
              :iconContent="editPen"
              iconStyle="width: 30px; height: 30px;"
            />
            <span>{{ $t("tabs.edit") }}</span>
          </SDialogTitle>
        </SDialogHeader>
        <SSeparator class="mb-0" />
        <input
          class="tab-name-input"
          :placeholder="$t('input.edit-order-name')"
          v-model="tabName"
        />
        <div v-if="recentlyUsedNames.length">
          <p class="recently-used">Recently used</p>
          <ul class="recent-name-list">
            <li v-for="name in recentlyUsedNames" :key="name">
              <h2 class="recent-name" @click="updateNameInput(name)">
                {{ name }}
              </h2>
              <SSeparator />
            </li>
          </ul>
        </div>
        <SDialogFooter class="gap-3">
          <SButton
            type="button"
            variant="outline"
            class="min-w-[120px]"
            @click="hideModal()"
          >
            {{ $t("button.cancel") }}
          </SButton>
          <SButton
            type="button"
            class="min-w-[120px]"
            :disabled="!tabName"
            @click="onSave()"
          >
            {{ $t("button.save") }}
          </SButton>
        </SDialogFooter>
      </SDialogContent>
    </SDialog>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from "vue";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import { ModalStatus } from "@/constants/modal";
import editPen from "@/assets/images/svg/edit-pen-rectangle.svg";
import ModalModule from "@/store/modules/modal";
import BookingModule from "@/store/modules/booking";
import {
  SButton,
  SDialog,
  SDialogContent,
  SDialogFooter,
  SDialogHeader,
  SDialogTitle,
  SSeparator,
} from "@smeetz/ui-core";

export default defineComponent({
  name: "TabNameEditModal",
  components: {
    SButton,
    SDialog,
    SDialogContent,
    SDialogFooter,
    SDialogHeader,
    SDialogTitle,
    SSeparator,
  },
  setup() {
    const modalVisibility = dialogVisibleForStatus(ModalStatus.TabNameEdit);
    const tabName = ref("");
    const recentlyUsedNames = computed(() => {
      return BookingModule.recentTabNames;
    });
    function hideModal() {
      ModalModule.setStatus(ModalStatus.Hidden);
    }
    function onSave() {
      BookingModule.setBookingTabName(tabName.value);
      BookingModule.addRecentTabName(tabName.value);
      hideModal();
    }
    function updateNameInput(name: string) {
      tabName.value = name;
    }
    return {
      modalVisibility,
      hideModal,
      onSave,
      editPen,
      tabName,
      updateNameInput,
      recentlyUsedNames,
    };
  },
});
</script>

<style lang="scss">
.tab-name-edit {
  .title {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  .tab-name-input {
    width: 100%;
    height: 100%;
    padding: 35px 24px;
    font-size: 24px;
    font-weight: 400;
    color: #333333;
    border: 0.5px solid gray;
    &::placeholder {
      color: #33333340;
    }
    margin-bottom: 1rem;
  }
  .tab-name-input:focus {
    outline: none;
  }

  .recent-name-list {
    list-style-type: none;
  }
  .recent-name {
    cursor: pointer;
    margin-top: 1.5rem;
  }
  .recently-used {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }
}
</style>
